// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 620 ? "pdfjsWorker" : chunkId) + "." + {"196":"fb14ec9b","583":"edfb0e01","620":"79c17c0a"}[chunkId] + ".chunk.js";
};